import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IAMGE_URL_BACK, IAMGE_URL_FRONT } from '@/components/model-2d';
import { ModelSolution } from '@/components/model-2d/model-config';
import { allAbdomenMoxInfo } from '@/components/model-2d/utils';
import moxCircleImg from '@/assets/image/mox-tip-circle.png';
import { selectCurrentServingOrder } from '@/store/service';

import cx from './index.module.scss';

interface Props {
  renderAreas: GetMoxibustionCompletedAreasResponse['moxibustion_areas'][0]['area'][];
}

// 矩阵艾灸穴位全量贴图
const textureImages = [
  ...ModelSolution['moxibustion']?.map(item => item.imageConfig.url),
  ...allAbdomenMoxInfo.map(item => item.imageConfig.url),
];

const MOX_AREA_INFO = [
  {
    name: '大椎穴区',
    info: '中心点位于身柱',
    areaId: 1,
  },
  {
    name: '心肺区',
    info: '中心点位于厥阴俞',
    areaId: 2,
  },
  {
    name: '脾胃区',
    info: '中心点位于脊中',
    areaId: 3,
  },
  {
    name: '命门区',
    info: '中心点位于命门',
    areaId: 4,
  },
  {
    name: '八髎区',
    info: '中心点位于膀胱俞',
    areaId: 5,
  },
  {
    name: '中脘区',
    info: '中心点位于中脘',
    areaId: 6,
  },
  {
    name: '关元穴区',
    info: '中心点位于气海',
    areaId: 7,
  },
];
const MoxPlanDetails: React.FC<Props> = ({ renderAreas }) => {
  const currentServingOrder = useSelector(selectCurrentServingOrder);

  // 模型背景图片
  const imgBgUrl = useMemo(
    () =>
      currentServingOrder?.bodyPart === 'Abdomen'
        ? IAMGE_URL_FRONT[currentServingOrder?.customerGender]
        : IAMGE_URL_BACK[currentServingOrder?.customerGender],
    [currentServingOrder]
  );

  return (
    <div className={cx('MoxPlanDetails')}>
      <div className={cx('wrapper')}>
        <img src={imgBgUrl} alt="" className={cx('bg-img')} />
        <div className={cx('texture-box')}>
          {textureImages.map((item, index) => (
            <div className={cx('texture-item')} key={index}>
              <img
                src={item}
                alt=""
                className={cx(`area-${index + 1}`, 'texture-img', { hide: !renderAreas?.includes((index as any) + 1) })}
              />
            </div>
          ))}
          {MOX_AREA_INFO.map(item => (
            <div
              className={cx('mox-label-item', `area-${item.areaId}`, {
                hide: !renderAreas?.includes(item.areaId as any),
              })}
              key={item.areaId}>
              <div className={cx('info-text')}>
                <div className={cx('name')}>{item.name}</div>
                <div className={cx('info')}>{item.info}</div>
              </div>
              <div className={cx('img-box')}>
                <img src={moxCircleImg} alt="" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoxPlanDetails;
